module.exports = __webpack_public_path__ + "img/experience-title.3b067df7.png";